import { Component, ViewContainerRef } from '@angular/core';
import { RepairDocketStore } from '../repair-docket.store';
import { MatDialog } from '@angular/material/dialog';
import { EditRepairsDocketSettingsComponent } from './edit-repair-docket-settings/edit-repairs-docket-settings.component';
import { REPAIR_DOCKET } from 'src/testIds';
import { KeyValuePairComponent } from '../../shared/general/key-value-pair/key-value-pair.component';
import { TestIdDirective } from '../../shared/directives/test-id.directive';
import { MatButton, MatAnchor } from '@angular/material/button';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { NgIf, AsyncPipe, TitleCasePipe } from '@angular/common';

@Component({
    selector: 'app-repair-docket-settings',
    templateUrl: './retail-docket-settings.component.html',
    standalone: true,
    imports: [NgIf, NgxSkeletonLoaderModule, MatButton, TestIdDirective, KeyValuePairComponent, MatAnchor, AsyncPipe, TitleCasePipe]
})
export class RetailDocketSettingsComponent {
  testIds = REPAIR_DOCKET;
  docket$ = this.repairDocketStore.docket$;
  docketLoading$ = this.repairDocketStore.docketLoading$;
  itemsLoading$ = this.repairDocketStore.itemsLoading$;
  canFinalizeDocket$ = this.repairDocketStore.canFinalize$;

  constructor(
    private repairDocketStore: RepairDocketStore,
    private dialog: MatDialog,
    private viewRef: ViewContainerRef
  ) {}

  finalize() {
    this.repairDocketStore.finalize();
  }

  openSettingsDialog() {
    this.dialog.open(EditRepairsDocketSettingsComponent, {
      viewContainerRef: this.viewRef
    });
  }
}
